export default "__VITE_PUBLIC_ASSET__5e842fcc__"